// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Image_wrapper__2h4bV","img":"Image_img__32oN2","imgGroup":"Image_imgGroup__P7sso","imgBlock":"Image_imgBlock__Ic-s0","imgBlockGrid":"Image_imgBlockGrid__2F491"};